// extracted by mini-css-extract-plugin
module.exports = {"root":"TableBody_root__GzITk"};